import { TaskProps, TaskStatus } from "../../types/interfaces";

const RANK_STEP = 1000;

function rankBetween(before: number | null, after: number | null): number {
  if (before === null && after === null) return RANK_STEP;
  if (before === null) return after! / 2;
  if (after === null) return before + RANK_STEP;
  return (before + after) / 2;
}

type BoardColumns = Record<string, TaskProps[]>;

export function computeDropResult(
  columns: BoardColumns,
  activeTaskId: string,
  overColumnStatus: TaskStatus,
  overTaskId: string | null
): { status: TaskStatus; rank: number } {
  const targetColumn = columns[overColumnStatus].filter((t) => t._id !== activeTaskId);

  if (overTaskId === null) {
    const lastRank = targetColumn.length > 0 ? targetColumn[targetColumn.length - 1].rank : null;
    return { status: overColumnStatus, rank: rankBetween(lastRank, null) };
  }

  const overIndex = targetColumn.findIndex((t) => t._id === overTaskId);
  const before = overIndex > 0 ? targetColumn[overIndex - 1].rank : null;
  const after = targetColumn[overIndex]?.rank ?? null;
  return { status: overColumnStatus, rank: rankBetween(before, after) };
}
